import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { toast } from '@grandvisionhq/common';
import { Util } from '@grandvisionhq/forms';
import { useIntl } from '@grandvisionhq/state';
import { useSignupCampaign } from '../../hooks/use-signup-campaign.js';
import { RichBannerCampaign } from './RichBannerCampaign.js';

const consents = [
    {
        titleKey: 'campaign.signup.consent',
        value: 'false',
        shouldItemValidate: false
    }, 
];
const optIns = [
    {
        titleKey: 'campaign.signup.optIn',
        value: 'false'
    }, 
];
const addFullTitleToItems = (getFormattedLabel, items)=>items.map((item)=>swcHelpers.objectSpread({}, item, {
            title: getFormattedLabel(item.titleKey)
        })
    )
;
const RichBannerCampaignContainer = (props)=>{
    const { getFormattedLabel  } = useIntl();
    const [selectedOptIns, setSelectedOptIns] = React.useState([]);
    const [selectedConsents, setSelectedConsents] = React.useState([]);
    const [formState, setFormState] = React.useState(Util.fieldsToFormState({
        firstName: '',
        middleName: '',
        lastName: '',
        email: ''
    }));
    const [signupCampaign, { loading , error , success  }] = useSignupCampaign();
    const handleSubmit = React.useCallback((state)=>{
        const { firstName , middleName , lastName , email  } = Util.getValuesFromState(state.formState);
        if (!(firstName && middleName && lastName && email)) {
            return;
        }
        signupCampaign({
            consents: addFullTitleToItems(getFormattedLabel, selectedConsents),
            optIns: addFullTitleToItems(getFormattedLabel, selectedOptIns),
            personalDetails: {
                firstName,
                middleName,
                lastName,
                email
            },
            campaignId: props.campaignId
        });
    }, [
        signupCampaign,
        selectedConsents,
        selectedOptIns,
        props.campaignId
    ]);
    const handleChange = (newState)=>setFormState(newState.formState)
    ;
    React.useEffect(()=>{
        if (error) {
            if (error === 'Signup to promotion failed due to missing consent.' /*'MISSING_CONSENT'*/ ) {
                toast.failed('campaign.signup.missing_consent');
            } else {
                toast.failed('campaign.signup.general_error');
            }
        } else if (success) {
            toast.success('campaign.signup.success');
            setFormState({});
        }
    }, [
        loading
    ]);
    return /*#__PURE__*/ React.createElement(RichBannerCampaign, swcHelpers.extends({}, props, {
        onSubmit: handleSubmit,
        formState: formState,
        onChange: handleChange,
        optIns: optIns,
        selectedOptIns: selectedOptIns,
        setSelectedOptIns: setSelectedOptIns,
        consents: consents,
        selectedConsents: selectedConsents,
        setSelectedConsents: setSelectedConsents,
        loading: loading
    }));
};

export { RichBannerCampaignContainer };
//# sourceMappingURL=RichBannerCampaignContainer.js.map
